import React, {Fragment, useState} from "react";
import {Col, Form, Input, Row} from "antd";
import {FormattedMessage} from "react-intl";
import {Tag} from "@models/tag";
import TagSelection from "@components/tags/Selection";
import {SelectionMode} from '@models';

interface TagProps {
  selectedTag: Tag | null;
  form: any;
}

const WidgetItemTagSelection: React.FC<TagProps> = props => {

  const {form, selectedTag} = props;
  const [tag, setTag] = useState(selectedTag || null);

  const onSelectTag = (tag: Tag) => {
    setTag(tag)
    form.setFieldsValue({
      tag: tag,
      tag_id: tag.id,
    });
  };
  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("tag", {
          initialValue: tag
        })(
          <Input type={`hidden`}/>
        )}
      </Form.Item>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item label={<FormattedMessage id="app.select_tag" defaultMessage={`Select Tag`}/>}>
            {form.getFieldDecorator("tag_id", {
              initialValue: tag ? tag.id : null,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.tag_is_required"
                      defaultMessage={`Select tag!`}
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <TagSelection mode={SelectionMode.DEFAULT}
                          onChange={onSelectTag}
                          initialValue={tag}/>
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  )
};

export default WidgetItemTagSelection;



